import { getCookie } from "@util/cookie";
import { checkGrayItem } from "@util/handleGrayByLocalstorage";

export const loadSubApp = (subApp) => {
  if (SUBAPP_MENU[subApp] && SUBAPP_MENU[subApp].status === 'loaded') {
    return Promise.resolve(SUBAPP_MENU[subApp]);
  } else {
    return global.vm.$staticUtils.createScript(SUBAPP_MENU[subApp].entry).then(res => {
      SUBAPP_MENU[subApp].status = 'loaded';
      return Promise.resolve(SUBAPP_MENU[subApp]);
    });
  }
};

export const addRoutes = (routes) => {
  global.vm.$router.addRoutes(routes);
};

export const navigateTo = (routeParams) => {
  global.vm.$router.push(routeParams);
};

export const SUBAPP_MENU = getSubAppMenu();

function getSubAppMenu () {
  let menus = {
    "/MenuManage/FoodManage/Upload": {
      entry: '/food-web/static/batch-upload-entry.js',
      status: 'unload',
    },
    '/BusinessReport/GetoDuty': {
      entry: '/report-dinein-web/static/gotoduty-entry.js',
      status: 'unload'
    },
    '/System/Download': {
      entry: '/report-component-web/static/appoint-download-entry.js',
      status: 'unload'
    },
    '/Payment/PayMethod': {
      entry: '/pay-web/static/hq-pay-entry.js',
      status: 'unload'
    },
  };

  if (checkGrayItem('pingxin_fe_hq-static_feature')) {
    delete menus["/System/Download"];
  }

  return menus;
}



// WEBPACK FOOTER //
// ./src/components/util/subApp.js